import { styled } from "@mui/joy";

export const Form = styled("form")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "stretch",
  rowGap: theme.spacing(2),
}));
